import React, { createContext, useContext, useState } from 'react';

const PermissionContext = createContext(null);

export const PermissionProvider = ({ children }) => {
    const permissions = {};
    const isLoading = false;

    // Stubs for common permission checks
    const canAdd = () => true;
    const canEdit = () => true;
    const canDelete = () => true;
    const canView = () => true;
    
    // hasPermission logic that matches what PermissionGate expects
    const hasPermission = (module, action) => {
        // Since this is a ported Todo feature into Feedback, 
        // we'll default to 'true' to allow the user to use the feature.
        return true; 
    };

    return (
        <PermissionContext.Provider value={{ permissions, isLoading, canAdd, canEdit, canDelete, canView, hasPermission }}>
            {children}
        </PermissionContext.Provider>
    );
};

export const usePermissions = () => useContext(PermissionContext);
